export default __webpack_public_path__ + "static/11-f4d3778bbc06512f96f6662fe65f0567.jpg";